import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ValidateEmpfRefNoRequest } from 'src/app/views/salesjourney/service/model/validate-empf-ref-no-request.model';
import { environment } from 'src/environments/environment';
import { catchError, timeout } from 'rxjs/operators';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { ValidateEmpfRefNoResponse } from './model/validate-empf-ref-no-response.model';
import { AgentSubmissionRequest } from './model/agent-submission-request.model';
import { AgentSubmissionResponse } from './model/agent-submission-response.model';
import { AgentInfoResponse, MultiAgentInfosResponse } from './model/agent-info-response.model';
import { CdHttpServeService } from 'src/app/shared/cd-http-serve/cd-http-serve.service';
import { CdsAlertService } from '@cds/ng-web-components/alert';
import { AgentChannelService } from 'src/app/core/services/agent-channel.service';
import { AgentChannel } from 'src/app/core/models/enum';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class IffService {
  private httpClient = inject(HttpClient);
  private cdHttpServeService = inject(CdHttpServeService);
  private alert = inject(CdsAlertService);
  private agentChannelService = inject(AgentChannelService);
  private authService = inject(AuthenticationService);

  validateEmpfRefNoUrl = `${environment.apiPrefix}${environment.salesJourneyServiceExt}/generateGeneralLink/validateEmpfRefNo/flow2`;
  agentSubmissionUrl = `${environment.apiPrefix}${environment.salesJourneyServiceExt}/generateGeneralLink/primaryAgentSubmission`;
  checkAgentUrl = `${environment.apiPrefix}${environment.agentServiceExt}/agent/information`;
  checkMultiAgentsUrl = `${environment.apiPrefix}${environment.agentServiceExt}/agent/infos/agentCd`;
  agentCodeConversion = `${environment.agentServiceExt}/api/v1/agent-code-conversion`;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  validateEmpfRefNoSubject = new Subject<ValidateEmpfRefNoResponse>();
  agentSubmissionSubject = new Subject<AgentSubmissionResponse>();
  agentInfoDataSubject = new Subject<AgentInfoResponse>();
  multiAgentInfosSubject = new Subject<MultiAgentInfosResponse>();
  thirdAgentInfoDataSubject = new Subject<AgentInfoResponse>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorIffSubject = new Subject<any>();

  validateEmpfRefNo(validateEmpfRefNoRequest: ValidateEmpfRefNoRequest): Subscription {
    return this.httpClient
      .post(this.validateEmpfRefNoUrl, validateEmpfRefNoRequest, this.httpOptions)
      .pipe(timeout(10000), catchError(this.handleError<ValidateEmpfRefNoResponse>('validate Empf Ref No got error')))
      .subscribe((resp: ValidateEmpfRefNoResponse) => {
        this.validateEmpfRefNoSubject.next(resp);
      });
  }

  agentSubmissionRequest(agentSubmissionRequest: AgentSubmissionRequest): Observable<AgentSubmissionResponse> {
    return this.httpClient
      .post<AgentSubmissionResponse>(this.agentSubmissionUrl, agentSubmissionRequest, this.httpOptions)
      .pipe(timeout(1000 * 60), catchError(this.handleError<AgentSubmissionResponse>('agent submission got error')));
  }

  agentSubmission(agentSubmissionRequest: AgentSubmissionRequest): Subscription {
    return this.agentSubmissionRequest(agentSubmissionRequest).subscribe((resp: AgentSubmissionResponse) => {
      this.agentSubmissionSubject.next(resp);
    });
  }

  getAgentInfo(agentcode: string) {
    this.httpClient
      .get(this.checkAgentUrl, { params: { agentInfo: agentcode } })
      .pipe(timeout(5000), catchError(this.handleError<AgentInfoResponse>('Get Agent(split case) got error')))
      .subscribe(resp => {
        this.agentInfoDataSubject.next(resp);
      });
  }

  getThirdAgentInfo(agentcode: string) {
    this.httpClient
      .get(this.checkAgentUrl, { params: { agentInfo: agentcode } })
      .pipe(timeout(5000), catchError(this.handleError<AgentInfoResponse>('Get third Agent(split case) got error')))
      .subscribe(resp => {
        this.thirdAgentInfoDataSubject.next(resp);
      });
  }

  getMultiAgentInfos(agentcodes: string[]) {
    this.httpClient
      .post(this.checkMultiAgentsUrl, agentcodes)
      .pipe(timeout(5000), catchError(this.handleError<MultiAgentInfosResponse>('Get multi Agent information(for ER split case) got error')))
      .subscribe(resp => {
        this.multiAgentInfosSubject.next(resp);
      });
  }

  handleError<T>(operation = 'operation', result?: T) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error: any): Observable<T> => {
      console.info(`${operation} failed :${error.message}`);
      this.errorIffSubject.next(`${error.message}`);
      return of(result as T);
    };
  }

  getAgentCode(identityId: string) {
    return this.cdHttpServeService.get<{ agentCode: string; agentName?: string | null; agentNameTC?: string | null }>(
      `${environment.agentServiceExt}/agent/getAgentCode`,
      { identityId }
    );
  }

  getServicingAgentCodeAndChannel() {
    this.authService.currentUserValue().then(res => {
      if (!res.id) {
        return;
      }
      const servicingAgentId = res.id + '';
      this.getAgentCode(servicingAgentId).subscribe({
        next: res => {
          if (res.result !== 0) {
            this.alert.warning('Warning!', `${res.message}`);
          } else {
            const servicingAgentCode = res.data ? res.data.agentCode : undefined;
            if (servicingAgentCode) {
              this.cdHttpServeService
                .post<
                  {
                    agentCode: string;
                    inputAgentType: string;
                    channel: string;
                    servicingAgentCode: string;
                    commissionAgentCode: string;
                  }[]
                >(this.agentCodeConversion, [servicingAgentCode])
                .subscribe(res => {
                  this.agentChannelService.channel = res.data[0].channel as AgentChannel;
                  this.agentChannelService.agentCode = res.data[0].agentCode;
                });
            }
          }
        },
      });
    });
  }
}
